import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldThrResponse } from '@/api/routes/stat/types';

import { fetchAggrDeviceTimeFieldThr } from './actionCreators';

interface InitialState {
  aggrThrByTimeField: AggrDeviceFieldThrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrThrByTimeField: [],
  isLoading: false,
  error: '',
};

export const aggrDeviceByTimeFieldSlice = createSlice({
  name: 'aggrDeviceByTimeField',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAggrDeviceTimeFieldThr.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldThrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.aggrThrByTimeField = action.payload;
    },
    [fetchAggrDeviceTimeFieldThr.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrDeviceTimeFieldThr.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggrDeviceByTimeFieldSlice.reducer;
